import React from "react"
import { useDebouncedCallback } from "use-debounce"
import RangeSlider from "../../../../../ui/molecules/RangeSlider"
import { FilterCategory, RangeFilterOption } from "../types"

interface Props {
  item: FilterCategory
  onItemUpdate: (item: FilterCategory) => void
  className?: string
}

const RangeFilterItem = ({ item, onItemUpdate, className }: Props) => {
  const option = item.options[0] as RangeFilterOption
  const handleChange = (values: number[]) => {
    onItemUpdate({
      ...item,
      options: [
        {
          ...option,
          values,
        },
      ],
    })
  }

  const debounced = useDebouncedCallback((values: number[]) => {
    handleChange(values)
  }, 100)

  return (
    <div className={className}>
      {/* <CustomBox px={2} flex="row" justifyContent="space-between">
        <Typography variant="body1">{option.values[0]} €</Typography>
        <Typography variant="body1">{option.values[1]} €</Typography>
      </CustomBox> */}
      <div className="pt-6 pb-4 pl-3 pr-8">
        <RangeSlider
          defaultValue={option.values as number[]}
          onChange={debounced}
          max={option.max as number}
        />
      </div>
    </div>
  )
}

export default RangeFilterItem
